export default __webpack_public_path__ + "static/media/thumb_04.9baeb2e3.jpg";